import { render, staticRenderFns } from "./reporte.vue?vue&type=template&id=15b624a6&scoped=true&"
import script from "./reporte.vue?vue&type=script&lang=js&"
export * from "./reporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b624a6",
  null
  
)

export default component.exports